import { useSetUserToThirdParty } from './useSetUserToThirdParty'

export default useSetUserToThirdParty
